const getSum = (arr: Array<number | undefined>) => {
  const removeUndefined = arr.filter((item) => item !== undefined);

  return removeUndefined.reduce((a, b) => a! + b!, 0);
};

export { getSum };
